
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ReportesService{

    async consultarCamposReporte(){
        let url = `${environment.backendUrl}/api/Reporte/CamposReporte`;
        let object=await (await fetch(url, {method: 'GET'})).json();
        return object;
    }

    async obtenerReporte(params: string[] = [""],
                         fechaInicial: Date = new Date(),
                         fechaFinal: Date = new Date(),
                         codigoRamo: number = 0,
                         codigoSucursal: number = 0,
                         codigoPuntoVenta: number = 0,
                         codigoAgente: number = 0){
        let campos = "";
        if(params)
            campos = params.reduce((previous, current) => previous+","+current.trim());

        let p={
            'str_campos': campos,
            'str_fecha_inicial': fechaInicial.toLocaleDateString("es-CO"),
            'str_fecha_fin': fechaFinal.toLocaleDateString("es-CO"),
            "in_cod_suc": codigoSucursal,
            "in_cod_ramo": codigoRamo,
            "in_cod_pto_vta": codigoPuntoVenta,
            "in_cod_agente": codigoAgente
        };

        let json=JSON.stringify(p);
        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
        let url=`${environment.backendUrl}/api/Reporte/Reporte`;
        let object=await (await fetch(url, request)).json();
        return object;
    }

    async obtenerReporteDocumentos(
                         condocumentos : boolean,
                         fechaInicial: string = "",
                         fechaFinal: string = "",
                         codigoRamo: number = 0,
                         codigoSucursal: number = 0,
                         codigoAgente: number = 0){

        let p={
            "in_cod_ramo": codigoRamo,
            "in_cod_suc": codigoSucursal,
            'con_documentos' : condocumentos,
            'str_fecha_inicial': fechaInicial,
            'str_fecha_fin': fechaFinal,
        };

        let json=JSON.stringify(p);
        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
        let url=`${environment.backendUrl}/api/Reporte/ReporteDocumentos`;
        let object=await (await fetch(url, request)).json();
        return object;
    }



    async obtenerGraficaPrimas(codigoRamo = 0, codigoSucursal = 0, codigoAgente = 0){
        let p={
            "str_campos": "",
            "str_fecha_inicial": "",
            "str_fecha_fin": "",
            "in_cod_suc": codigoSucursal,
            "in_cod_ramo": codigoRamo,
            "in_cod_agente": codigoAgente,
            "in_cod_pto_vta": 0
        };

        let json=JSON.stringify(p);

        let request: RequestInit={
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json;charset=utf-8"
            },
            method: 'POST',
            body: json
        };
        let url=`${environment.backendUrl}/api/Reporte/GraficaPrimas`;
        let object=await (await fetch(url, request)).json();
        return (object.length > 0) ? object[0].total_prima : 0;
    }

    async obtenerGraficaPolizas(codigoRamo = 0, codigoSucursal = 0, codigoAgente = 0){
        let p={
            "str_campos": "",
            "str_fecha_inicial": "",
            "str_fecha_fin": "",
            "in_cod_suc": codigoSucursal,
            "in_cod_ramo": codigoRamo,
            "in_cod_agente": codigoAgente,
            "in_cod_pto_vta": 0
        };

        let json=JSON.stringify(p);

        let request: RequestInit={
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json;charset=utf-8"
                },
                method: 'POST',
                body: json
            };
            let url=`${environment.backendUrl}/api/Reporte/GraficaPolizas`;
            let object=await (await fetch(url, request)).json();
            return (object.length > 0) ? object[0].cantidad : 0;
    }

}
